import clsx from "clsx";
import React from "react";
import { createPluggable } from "pluggable-react";
import styles from "./Tree.module.scss";

export interface TreeLineProps extends React.HTMLAttributes<HTMLSpanElement> {
  showBottomLine?: boolean;
  showTopLine?: boolean;
  showRightLine?: boolean;
}

const DefaultTreeLine = ({
  className,
  showBottomLine,
  showTopLine,
  showRightLine,
  ...props
}: TreeLineProps) => {
  return (
    <span
      className={clsx(styles.treeLine, className)}
      data-show-bottom-line={showBottomLine ? "true" : "false"}
      data-show-top-line={showTopLine ? "true" : "false"}
      data-show-right-line={showRightLine ? "true" : "false"}
      {...props}
    />
  );
};

const TreeLine = createPluggable<TreeLineProps>("deci.tree.line", DefaultTreeLine);

export default TreeLine;
